"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFeature = void 0;
var feature_flag_context_1 = require("./feature-flag-context");
/**
 * get the variant value of a specific feature flag - requires identification
 * @param flagName - the name of the flag
 * @param defaultValue - a default value in case the flag does not exist or the client is still loading
 * @param options
 * @param options.shouldTrack - whether should send analytics track event on fetching variant. undefined defaults to true.
 * for development purposes
 *
 * @returns [value, isLoading]
 *  value - the variant value (taking into account defaultValue and overrides)
 *  isLoading - whether the client is still loading.
 */
var useFeature = function (flagName, defaultValue, options) { return (0, feature_flag_context_1.useFeatureBase)(flagName, false, defaultValue, options); };
exports.useFeature = useFeature;
